import { render } from "./ModalPeopleEdit.vue?vue&type=template&id=e78c4c54&scoped=true"
import script from "./ModalPeopleEdit.vue?vue&type=script&lang=js"
export * from "./ModalPeopleEdit.vue?vue&type=script&lang=js"

import "./ModalPeopleEdit.vue?vue&type=style&index=0&id=e78c4c54&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78c4c54"]])

export default __exports__